import React from "react";
import { Switch, Route, Link } from "react-router-dom";
import Overview from "./Overview";
import StandardFunctions from "./StandardFunctions";

const HelpHome = (props) => {
  return (
    <div className="col">
      <Link to="/help">Home</Link>
      <Switch>
        <Route path="/help/functions" component={StandardFunctions} />
        <Route path="/help" exact component={Overview} />
      </Switch>
    </div>
  );
};

export default HelpHome;
